import { getTooltipAttributes } from "@common/contexts/Tooltip";
import { IconAction } from "@common/controls/Icon/component";
import { IconType } from "@common/declarations";
import React from "react";

type Props = {
  caption?: string;
  icon: IconType;
  isActive: boolean;
  isDisabled?: boolean;

  onMouseDown: () => void;
  tooltip?: string;
};
const MenuButtonBase = React.forwardRef((props: Props, ref: React.RefObject<HTMLDivElement>) => (
  <div className="item" ref={ref} {...getTooltipAttributes(props.tooltip)}>
    <IconAction
      isActive={props.isActive}
      isDisabled={props.isDisabled}
      onMouseDown={(e) => {
        e.preventDefault();

        !props.isDisabled && props.onMouseDown();
      }}
      icon={props.icon}
      size={28}
    />
    {props.caption}
  </div>
));
export default MenuButtonBase;
